import api from './api';

export interface NotificationActor {
  id: string;
  username: string;
  profileImageUrl?: string;
}

export interface Notification {
  id: string;
  type: number;
  typeName: string;
  isRead: boolean;
  createdAt: string;
  readAt?: string;
  actor?: NotificationActor;
  reviewId?: string;
  commentId?: string;
  message?: string;
  badgeKey?: string;
}

export interface NotificationListResponse {
  notifications: Notification[];
  unreadCount: number;
  totalCount: number;
}

export const notificationsService = {
  async getNotifications(page = 1, pageSize = 20): Promise<NotificationListResponse> {
    const response = await api.get<NotificationListResponse>('/notifications', {
      params: { page, pageSize },
    });
    return response.data;
  },

  async getUnreadCount(): Promise<number> {
    const response = await api.get<{ unreadCount: number }>('/notifications/unread-count');
    return response.data.unreadCount;
  },

  async markAsRead(id: string): Promise<void> {
    await api.post(`/notifications/${id}/read`);
  },

  async markAllAsRead(): Promise<void> {
    await api.post('/notifications/read-all');
  },
};
